export const DROPDOWN_FONT_SIZE = 10;
//# sourceMappingURL=WhiteLabelMobileDropdownConstant.js.map